<template>
    <div id="app">
        <Header></Header>
        <router-view />
        <Footer></Footer>
        <Subscribe :popup="true"></Subscribe>
        <Assets></Assets>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import Subscribe from '@/components/Subscribe.vue';
import Assets from '@/components/Assets.vue';

export default {
    name: 'App',
    components: {
        Header,
        Footer,
        Subscribe,
        Assets,
    },
    computed: mapState(['site']),
    metaInfo() {
        return {
            title: this.site.metaTitle,
            meta: [
                { name: 'description', content: this.site.metaDescription },
                { property: 'og:title', content: this.site.metaTitle },
                { property: 'og:site_name', content: this.site.metaTitle },
                { property: 'og:description', content: this.site.metaDescription },
                { property: 'og:type', content: 'article' },
                { property: 'og:url', content: window.location.href },
                { property: 'og:image', content: this.site.ogImage ? this.site.ogImage : null },
            ],
        };
    },
    created() {
        this.loadSite();
    },
    methods: {
        ...mapActions(['loadSite']),
    },
};
</script>

<style lang="scss"></style>
